export default "__VITE_ASSET__BP8aF_rl__"